app = angular.module 'app', [
  'ionic'
  'ionic-material'
]

app.config ($stateProvider, $urlRouterProvider) ->

  $stateProvider
    .state 'app',
      url: ''
      abstract: true
      templateUrl: 'apps/templates/menu'
      controller: 'AppController'
      resolve:
        activeProject: ($http, $location, $ionicPopup, $state, activeUser, config) ->
          getParameterByName = (name) ->
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
            regexS = "[\\?&]" + name + "=([^&#]*)"
            regex = new RegExp(regexS)
            results = regex.exec(window.location.search)
            unless results?
              ""
            else
              decodeURIComponent results[1].replace(/\+/g, " ")

          group_id = getParameterByName 'group_id'
          activeUser.group_id = group_id
          activeUser.user = {headimgurl: ''}
          openid = getParameterByName 'openid'
          wechat_id = getParameterByName 'wechat_id'
          activeUser.wechat_id = wechat_id
          if group_id and openid
            $http.get "#{config.api.baseUrl}/fans-get/#{openid}", {}
            .then (res) ->
              userInfo = res.data
              userInfo.headimgurl = "http://microdata2-api.ersinfotech.com/imgserve?_url=#{userInfo.headimgurl}"
              activeUser.user = userInfo
            .then ->
              $http.get "#{config.api.baseUrl}/cumpus/homepage",
                params:
                  group_id: group_id
              .then (res) ->
                if res.data.data.length > 0
                  activeUser.homepage = res.data.data[0]
              .catch (error) ->
            .catch (error) ->
              $ionicPopup.alert(
                title: "错误"
                template: "获取用户信息失败"
                buttons: [
                  {text: '<b>关闭</b>', type: 'button-positive'}
                ]
              )

          else
            $http.get "#{config.api.baseUrl}/cumpus/homepage",
                params:
                  group_id: group_id
              .then (res) ->
                if res.data.data.length > 0
                  activeUser.homepage = res.data.data[0]
              .catch (error) ->
            # $state.go('focus_on', {wechat_id: wechat_id})

    .state 'app.home',
      cache: true
      url: '/home'
      views:
        'menuContent':
          templateUrl: 'apps/templates/home'
          controller: 'HomeController'

    .state 'app.article_list',
      cache: true
      url: '/article_list/:column_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/article_list'
          controller: 'ArticleListController'

    .state 'app.single_article',
      cache: true
      url: '/single_article/:column_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/single_article'
          controller: 'SingleArticleController'

    .state 'app.top_new',
      cache: true
      url: '/top_new/:new_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/top_new'
          controller: 'TopNewController'

    .state 'app.article',
      cache: true
      url: '/article/:column_id/:article_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/article'
          controller: 'ArticleController'

    .state 'app.images',
      cache: true
      url: '/images/:column_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/images'
          controller: 'ImagesController'

    .state 'app.external_link',
      cache: true
      url: '/external_link/:column_id'
      views:
        'menuContent':
          templateUrl: 'apps/templates/external_link'
          controller: 'ExternalLinkController'

    # 身份驗證
    .state 'app.authentication_info',
      cache: false
      url: '/authentication_info/:status'
      views:
        'menuContent':
          templateUrl: 'apps/templates/authentication_info'
          controller: 'AuthenticationInfoController'

    .state 'app.verify_success',
      cache: false
      url: '/verify_success/:user_id/:status'
      views:
        'menuContent':
          templateUrl: 'apps/templates/verify_success'
          controller: 'VerifySuccessController'

    # 关注页面
    .state 'focus_on',
      cache: false
      url: '/focus_on/:wechat_id'
      templateUrl: 'apps/templates/focus_on'
      controller: 'FocusOnController'

  $urlRouterProvider.otherwise('/home')


